import { __decorate } from "tslib";
import { Component, Prop, Mixins } from 'vue-property-decorator';
import BaseTextField from './BaseTextField.vue';
import FormValidationsMixin from '../../helpers/vue_mixins/v2/FormValidationsMixin';
import { MOBILE_MASK } from '../../helpers/constants/app';
let MerchantSignatories = class MerchantSignatories extends Mixins(FormValidationsMixin) {
    get mobileMask() {
        return MOBILE_MASK;
    }
};
__decorate([
    Prop({ type: Boolean, default: false })
], MerchantSignatories.prototype, "initial", void 0);
__decorate([
    Prop({ type: Object, required: true })
], MerchantSignatories.prototype, "signatory", void 0);
MerchantSignatories = __decorate([
    Component({
        components: {
            BaseTextField,
        },
    })
], MerchantSignatories);
export default MerchantSignatories;
